import { toast } from "react-toastify";
import React from "react";
import { IoClose } from "react-icons/io5";

// Single toast ID to avoid duplicates for normal messages
const TOAST_ID = "global-toast";
// Separate toast ID for global error handler
const GLOBAL_ERROR_TOAST_ID = "global-error-toast";

// Toast UI component
const ToastContent = ({ message, closeToast }) => (
  <div className="d-flex align-items-center justify-content-between w-100">
    <span>{message}</span>
    <IoClose
      onClick={closeToast}
      style={{ cursor: "pointer", marginLeft: "10px" }}
      size={20}
    />
  </div>
);

// Show success toast
export const showSuccessToast = (message = "Success") => {
  if (toast.isActive(TOAST_ID)) {
    toast.update(TOAST_ID, {
      render: ({ closeToast }) => (
        <ToastContent message={message} closeToast={closeToast} />
      ),
      type: "success",
      autoClose: 3000,
      isLoading: false,
    });
  } else {
    toast(
      ({ closeToast }) => (
        <ToastContent message={message} closeToast={closeToast} />
      ),
      {
        toastId: TOAST_ID,
        type: "success",
        autoClose: 3000,
      }
    );
  }
};

// Show normal error toast
export const showErrorToast = (message = "Something went wrong") => {
  if (toast.isActive(TOAST_ID)) {
    toast.update(TOAST_ID, {
      render: ({ closeToast }) => (
        <ToastContent message={message} closeToast={closeToast} />
      ),
      type: "error",
      autoClose: 3000,
      isLoading: false,
    });
  } else {
    toast(
      ({ closeToast }) => (
        <ToastContent message={message} closeToast={closeToast} />
      ),
      {
        toastId: TOAST_ID,
        type: "error",
        autoClose: 3000,
      }
    );
  }
};

// 🔹 New: Show Global Error toast (independent of normal toast)
export const showGlobalErrorToast = (message = "Something went wrong") => {
  toast(
    ({ closeToast }) => (
      <ToastContent message={message} closeToast={closeToast} />
    ),
    {
      toastId: GLOBAL_ERROR_TOAST_ID,
      type: "error",
      autoClose: 5000, // slightly longer for global errors
      isLoading: false,
      position: "top-right", // optional: global error position
    }
  );
};

// Show info toast (for neutral messages like "In Review")
export const showInfoToast = (message = "Info", options = {}) => {
  const toastId = options.toastId || TOAST_ID;
  const autoClose =
    Number.isFinite(Number(options.autoClose)) && Number(options.autoClose) > 0
      ? Number(options.autoClose)
      : 3000;

  if (toast.isActive(toastId)) {
    toast.update(toastId, {
      render: ({ closeToast }) => (
        <ToastContent message={message} closeToast={closeToast} />
      ),
      type: "info",
      autoClose,
      isLoading: false,
    });
  } else {
    toast(
      ({ closeToast }) => (
        <ToastContent message={message} closeToast={closeToast} />
      ),
      {
        toastId,
        type: "info",
        autoClose,
      }
    );
  }
};

// Show warning toast (for nearing limits, etc.)
export const showWarningToast = (message = "Warning") => {
  if (toast.isActive(TOAST_ID)) {
    toast.update(TOAST_ID, {
      render: ({ closeToast }) => (
        <ToastContent message={message} closeToast={closeToast} />
      ),
      type: "warning",
      autoClose: 4500,
      isLoading: false,
    });
  } else {
    toast(
      ({ closeToast }) => (
        <ToastContent message={message} closeToast={closeToast} />
      ),
      {
        toastId: TOAST_ID,
        type: "warning",
        autoClose: 4500,
      }
    );
  }
};
